// 商品一覧のタブ切り替えをページ全体の再読み込みなしで行う。
// 同じタブ構成のページ間だけ、パンくず・タイトル・絞り込み・商品一覧の中身を差し替え、それ以外は通常の遷移にする。
(() => {
  if (window.giraffeCollectionTabs || (window.Shopify && window.Shopify.designMode)) return;
  window.giraffeCollectionTabs = true;

  const TAB_SELECTOR = '.giraffe-collection-toolbar__navigation a.giraffe-collection-toolbar__link';
  const SWAP_SELECTORS = [
    '.breadcrumb__list',
    '.page-title__content',
    '.giraffe-collection-toolbar__facets',
    '#ProductGridContainer',
  ];

  const pageCache = new Map();
  let displayedPath = window.location.pathname;
  let pendingUrl = null;

  const tabSignature = (root) =>
    Array.from(root.querySelectorAll(TAB_SELECTOR), (link) => link.getAttribute('href')).join('|');

  const fetchPage = (url) => {
    if (!pageCache.has(url)) {
      const request = fetch(url, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.text();
      });
      request.catch(() => pageCache.delete(url));
      pageCache.set(url, request);
    }
    return pageCache.get(url);
  };

  // 既に読み込み済みのスタイルシートはそのまま残し、ちらつきを防ぐ
  const swapChildren = (current, next) => {
    const loaded = new Set(
      Array.from(document.querySelectorAll('link[rel="stylesheet"]'), (link) => link.getAttribute('href'))
    );
    Array.from(current.childNodes).forEach((node) => {
      if (node.nodeName !== 'LINK') node.remove();
    });
    Array.from(next.childNodes).forEach((node) => {
      if (node.nodeName === 'LINK' && loaded.has(node.getAttribute('href'))) return;
      current.appendChild(node);
    });
  };

  const isTabLink = (link, event) => {
    if (!link || event.defaultPrevented || event.button !== 0) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (link.target && link.target !== '_self') return false;
    const url = new URL(link.href, window.location.href);
    return url.origin === window.location.origin && url.pathname.includes('/collections/');
  };

  const scrollToToolbar = () => {
    const toolbar = document.querySelector('.giraffe-collection-toolbar');
    if (!toolbar) return;
    const header = document.querySelector('.section-header');
    const offset = header ? header.offsetHeight : 0;
    const top = toolbar.getBoundingClientRect().top - offset;
    if (top < 0) window.scrollTo({ top: window.scrollY + top, behavior: 'auto' });
  };

  const navigate = async (url) => {
    pendingUrl = url;
    const collection = document.querySelector('#ProductGridContainer .collection');
    if (collection) collection.classList.add('loading');

    try {
      const html = await fetchPage(url);
      if (pendingUrl !== url) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');

      if (tabSignature(doc) !== tabSignature(document)) throw new Error('different tab group');
      const pairs = SWAP_SELECTORS.map((selector) => [document.querySelector(selector), doc.querySelector(selector)]);
      if (pairs.some(([current, next]) => Boolean(current) !== Boolean(next))) throw new Error('layout mismatch');

      pairs.forEach(([current, next]) => {
        if (current && next) swapChildren(current, next);
      });

      const currentFilters = document.getElementById('main-collection-filters');
      const nextFilters = doc.getElementById('main-collection-filters');
      if (currentFilters && nextFilters) currentFilters.dataset.id = nextFilters.dataset.id;

      const nextTabs = doc.querySelectorAll(TAB_SELECTOR);
      document.querySelectorAll(TAB_SELECTOR).forEach((link, index) => {
        const next = nextTabs[index];
        link.className = next.className;
        if (next.hasAttribute('aria-current')) {
          link.setAttribute('aria-current', next.getAttribute('aria-current'));
        } else {
          link.removeAttribute('aria-current');
        }
      });

      const nextUrl = new URL(url, window.location.href);
      document.title = doc.title;
      window.history.pushState(
        { searchParams: nextUrl.search.slice(1), giraffeCollectionTab: true },
        '',
        nextUrl.pathname + nextUrl.search
      );
      displayedPath = window.location.pathname;

      scrollToToolbar();

      const grid = document.getElementById('ProductGridContainer');
      if (grid && typeof window.initializeScrollAnimationTrigger === 'function') {
        window.initializeScrollAnimationTrigger(grid);
      }

      if (window.StandardEvents && window.StandardEvents.PageViewEvent) {
        document.dispatchEvent(
          new window.StandardEvents.PageViewEvent({
            page: { template: 'collection', title: document.title, url: window.location.href },
          })
        );
      }
    } catch (error) {
      if (pendingUrl === url) window.location.href = url;
    } finally {
      if (pendingUrl === url) {
        pendingUrl = null;
        const current = document.querySelector('#ProductGridContainer .collection');
        if (current) current.classList.remove('loading');
      }
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(TAB_SELECTOR);
    if (!isTabLink(link, event)) return;
    event.preventDefault();
    const url = new URL(link.href, window.location.href);
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    navigate(url.href);
  });

  // マウスを乗せた時点で先読みしておく
  document.addEventListener(
    'pointerenter',
    (event) => {
      const link = event.target instanceof Element ? event.target.closest(TAB_SELECTOR) : null;
      if (!link || link.classList.contains('is-active')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin === window.location.origin && url.pathname.includes('/collections/')) fetchPage(url.href);
    },
    true
  );

  // 戻る・進むで別のコレクションに移るときは通常どおり読み込み直す（同じコレクション内の絞り込みは facets.js が処理）
  window.addEventListener('popstate', () => {
    if (window.location.pathname !== displayedPath) window.location.reload();
  });
})();
